<template>
	<div class="container">

		<header class="container__header">

			<h1>Find tilpasset ordre</h1>

		</header>


		<div class="container__body container__body--md">
            <div class="wrap--xsm__left margin-b-75">

                <form class="col-12" @submit.prevent="searchForOrders">

                    <label>Hvilke ordre leder du efter?</label>

                    <div class="search">

                        <input class="col-12" type="text" name="name" autocomplete="off" placeholder="Find ordre" v-model="searchTerm">

                        <button class="btn btn--md btn--primary primary--copper">

                            <span>Søg</span>

                        </button>

                    </div>

                    <div class="col-12 margin-t-25">

                        <p class="tips">*Søg på ordrenr, navn, e-mail, tlf.</p>

                    </div>

                </form>

            </div>
			<section class="search-result margin-t-75">

				<div class="filters margin-b-50 border-b padding-b-25">

					<h1>Resultat</h1>

					<nav>

						<ul>
							<li>Filtrer søgning: </li>
							<li><a href="#" :class="[currentFilter == 'all' ? 'active':'']" @click.prevent="changeFilter('all')">Alle ({{all.length}})</a></li>
							<li><a href="#" :class="[currentFilter == 'active' ? 'active':'']"  @click.prevent="changeFilter('active')">Åbne ({{active.length}})</a></li>
							<li><a href="#" :class="[currentFilter == 'delivered' ? 'active':'']" @click.prevent="changeFilter('delivered')">Udleveret ({{delivered.length}})</a></li>
							<li><a href="#" :class="[currentFilter == 'refunded' ? 'active':'']" @click.prevent="changeFilter('refunded')">Refunderet ({{refunded.length}})</a></li>
						</ul>

					</nav>

				</div>

				<transition-group name="fade" mode="out-in">

					<order v-for="(order, index) in currentResult" :order="order" @reload="reload" :key="`${order.id}-${index}`" v-if="!changingFilter"></order>

					<div class="no-result margin-t-25" v-if="currentResult.length === 0 && !changingFilter" key="notfound">

						<i class="icon--lg fas fa-sad-tear"></i>

						<h4>Ingen resultater fundet</h4>

					</div>

				</transition-group>

			</section>

		</div>

	</div>
</template>

<script>
	import Order from './components/order.vue';
    import {mapGetters} from 'vuex';
    export default {
        name:'order-search',
		components:{
          	Order
		},
        data(){
            return {
                searchTerm:'',
                all:[],
				active:[],
				delivered:[],
				refunded:[],
				currentFilter:'all',
				changingFilter:false,
				chosenProduct:null,
				searchState: 'choose',
			};
		},
		computed:{
			currentResult(){
				switch (this.currentFilter) {
					case 'active':
					    return this.active;
					case 'delivered':
					    return this.delivered;
					case 'refunded':
					    return this.refunded;
					case 'all':
					default:
					    return this.all;
                }
			},
		},
		methods:{
			getAllOrders(){
			    this.chosenProduct = null;
                this.currentFilter = 'all';
			    axios.post(`/api/admin/productless/order/search`, {search:''}).then(response=>{
                    console.log(response.data.data.active);
                    this.all = Array.isArray(response.data.data.all) ? response.data.data.all: Object.keys(response.data.data.all).map(key=>[Number(key), response.data.data.all[key]]);
                    this.active = Array.isArray(response.data.data.active) ? response.data.data.active : Object.keys(response.data.data.active).map(key=>[Number(key), response.data.data.active[key]]);
                    this.delivered = Array.isArray(response.data.data.delivered) ? response.data.data.delivered : Object.keys(response.data.data.delivered).map(key=>[Number(key), response.data.data.delivered[key]]);
                    this.refunded = Array.isArray(response.data.data.refunded) ? response.data.data.refunded : Object.keys(response.data.data.refunded).map(key=>[Number(key), response.data.data.refunded[key]]);
                });
			},
			searchForOrders(){
                this.chosenProduct = null;
                this.currentFilter = 'all';
                axios.post(`/api/admin/productless/order/search`, {search:this.searchTerm}).then(response=>{
                    console.log(response.data.data);
                    this.searchTerm = '';
                    this.all = Array.isArray(response.data.data.all) ? response.data.data.all: Object.keys(response.data.data.all).map(key=>[Number(key), response.data.data.all[key]]);
                    this.active = Array.isArray(response.data.data.active) ? response.data.data.active : Object.keys(response.data.data.active).map(key=>[Number(key), response.data.data.active[key]]);
                    this.delivered = Array.isArray(response.data.data.delivered) ? response.data.data.delivered : Object.keys(response.data.data.delivered).map(key=>[Number(key), response.data.data.delivered[key]]);
                    this.refunded = Array.isArray(response.data.data.refunded) ? response.data.data.refunded : Object.keys(response.data.data.refunded).map(key=>[Number(key), response.data.data.refunded[key]]);
                });
			},
			reload(){
				if(this.searchTerm){
					return this.searchForOrders();
				}

				this.getAllOrders();
			},
			changeFilter(type){
			    this.changingFilter = true;
				this.currentFilter = type;
			    setTimeout(()=>{
					this.changingFilter = false;
				}, 500);
			}
		},
		created(){
            if(this.$route.params.order){
                this.searchTerm = this.$route.params.order
				return this.searchForOrders();
			}

			this.getAllOrders();
		}
    }
</script>
